<template>
    <div class="filter-wrapper" :class="'filter-wrapper__'+filterType" v-show="facets && facets.length > 0">
        <portal-mobile portal-to="mobile-filter" :breakpoint="992">
            <item-filter :filter-type="filterType"
                         :is-mobile="isMobile"
                         v-for="facet in facets"
                         :facet="facet"
                         :key="facet.id">
            </item-filter>
            <button v-show="selectedFacets && selectedFacets.length > 0"
                    class="item-filter__clear-all"
                    @click="clearAllFacets()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="15">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-reset"></use>
                </svg>
                {{ $translate("OD3dprimaV2::Template.categoryResetFilters") }}
            </button>
        </portal-mobile>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ItemFilter from "./ItemFilter.vue";

export default {

    name: "item-filter-list",

    components:
    {
        ItemFilter
    },

    props: {
        filterType: {
            type: String,
            default: 'dropdown'
        },
        filterListBulk: Boolean,
        facetData:
        {
            type: Array,
            default()
            {
                return [];
            }
        },
        allowedFacetsTypes:
        {
            type: Array,
            default: () => []
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        }
    },

    data()
    {
        return {
            initialSelectedFacets: [],
            windowWidth: 0
        };
    },

    computed:
    {
        ...mapState({
            facets(state) {

                let facets = state.itemList.facets;

                let priceFacetIndex        = facets.findIndex(facet => facet.type === 'price');
                let availabilityFacetIndex = facets.findIndex(facet => facet.type === 'availability');

                //move price always first
                if(priceFacetIndex > -1) {
                    facets.splice(0, 0, facets.splice(priceFacetIndex, 1)[0]);
                }

                //move price always second
                if(availabilityFacetIndex > -1) {
                    facets.splice(1, 0, facets.splice(availabilityFacetIndex, 1)[0]);
                }

                if (!this.allowedFacetsTypes.length) {
                    return state.itemList.facets;
                }

                return state.itemList.facets
                    .filter(facet => this.allowedFacetsTypes.includes(facet.id) || this.allowedFacetsTypes.includes(facet.type));
            },
            isLoading: state => state.itemList.isLoading,
            selectedFacets: state => state.itemList.selectedFacets
        }),
        isMobile(){
            return this.windowWidth < 992;
        }
    },

    created()
    {
      if (!this.$store.state.itemList.facets?.length)
      {
        this.$store.commit("addFacets", this.facetData);
      }
    },

    mounted()
    {
        this.windowWidth = window.innerWidth;

        this.$nextTick(() => {
            $('body').on('click','.dropdown-menu.keep-open', function (e) {
                e.stopPropagation();
            });
        })
    },

    beforeDestroy()
    {
        window.removeEventListener('resize', this.onResize);
    },

    methods:
    {
        onResize() {
            this.windowWidth = window.innerWidth;
        },

        initPriceFacet(urlParams)
        {
            if (urlParams.priceMin || urlParams.priceMax)
            {
                const priceMin = urlParams.priceMin || '';
                const priceMax = urlParams.priceMax || '';

                this.$store.commit('setPriceFacet', { priceMin: priceMin, priceMax: priceMax });

                return true;
            }

            return false;
        },

        clearAllFacets()
        {
            this.$store.commit('resetAllSelectedFacets');
            this.$store.dispatch('loadItemList')
        }
    }
}
</script>
